import { CSSProperties, ReactNode, Ref } from "react";
import { twMerge } from "tailwind-merge";

type TwoPanelLayoutProps = {
  first: ReactNode;
  second: ReactNode;
  firstPart?: string;
  secondPart?: string;
  firstRef?: Ref<HTMLDivElement>;
  secondRef?: Ref<HTMLDivElement>;
  firstClassName?: string;
  secondClassName?: string;
  className?: string;
  style?: CSSProperties;
};

export const TwoPanelLayout = ({
  first,
  second,
  firstPart = "1fr",
  secondPart = "1fr",
  firstRef,
  secondRef,
  firstClassName,
  secondClassName,
  className,
  style,
}: TwoPanelLayoutProps) => (
  <div
    className={twMerge(
      "grid h-full min-h-0 overflow-hidden print:block print:h-auto print:w-screen print:overflow-visible",
      className,
    )}
    style={{
      gridTemplateColumns: `${firstPart} ${secondPart}`,
      ...style,
    }}
  >
    <div
      ref={firstRef}
      className={twMerge(
        "h-full min-w-0 overflow-x-hidden overflow-y-auto overscroll-contain print:h-auto print:max-h-screen",
        firstClassName,
      )}
    >
      {first}
    </div>
    <div
      ref={secondRef}
      className={twMerge(
        "h-full min-w-0 overflow-x-hidden overflow-y-auto overscroll-contain print:h-auto print:max-h-screen print:overflow-visible",
        secondClassName,
      )}
    >
      {second}
    </div>
  </div>
);
